var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3"},[_c('b-alert',{attrs:{"dismissible":"","show":"","variant":_vm.variant}},[_vm._v("\n        "+_vm._s(_vm.msg)+"\n        "),(_vm.errorMsg)?_c('ul',_vm._l((_vm.errorMsg),function(value,key){return _c('li',{key:key},[_vm._v("\n                "+_vm._s(value[0])+"\n            ")])}),0):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }